<template>
  <div id="numberAnswers">
    <div class="columns is-multiline is-centered is-mobile">
      <div v-for="(ans, index) in answers" :key="`answer-${index}`" class="column is-4">
        <figure class="image answerOption" draggable="false">
          <a href="#" draggable="false" @click.prevent="sendAnswer(ans)"><p :class="{'small': ans.answer.length >= 4 && ans.answer.length <= 6, 'xsmall': ans.answer.length > 6}">{{ enforceLatinNumberSystem(parseFloat(ans.answer.toString().replace(',', ''))) }}</p>
            <img src="/images/answerPlanet.png" draggable="false"></a>
        </figure>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { enforceLatinNumberSystem } from '@/edshed-common/api'

@Component
export default class NumberAnswers extends Vue {
  @Prop({ type: Array, required: true }) answers!: number[]

  enforceLatinNumberSystem = enforceLatinNumberSystem

  get soundFXOn (): boolean {
    return this.$store.state.soundFXOn
  }

  get clickSound (): any {
    return this.$sounds.clickSound
  }

  sendAnswer (ans) {
    if (this.$store.state.soundFXOn) {
      this.$sounds.clickSound.play()
    }
    this.$emit('answerClicked', ans)
  }
}
</script>
<style scoped>
  #numberAnswers {
    max-width: 960px;
    margin: 50px auto 0;
  }
  .answerOption {
    width: 150px;
    margin:0 auto 40px;
    -webkit-transition: -webkit-transform .25s ease-in-out;
    transition: transform .25s ease-in-out;
  }

  .answerOption p {
    position: absolute;
    text-align: center;
    width: 150px;
    margin:0 auto;
    height: 100%;
    top:25%;
    left: 0;
    right: 0;
    color: white;
    font-size: 3em;
    font-family: var(--user-chosen-font);
  }
  .answerOption p.small {
    font-size: 1.8em;
    top: 35%;
  }

  .answerOption p.xsmall {
    font-size: 1.3em;
    top: 40%;
  }

  @media (hover: hover) {
    .answerOption:hover {
      -webkit-transform: rotate(10deg) scale(1.1);
      transform: rotate(10deg) scale(1.1);
    }
  }

  @media only screen and (max-width : 640px) {
    .answerOption {
      width:100px;
      margin:0 auto;
    }
    .answerOption p {
      width:100px;
      top: 17%;
    }

    .answerOption p.small {
      font-size: 1.2em;
      top: 40%;
    }

    .answerOption p.xsmall {
      font-size: 1.0em;
      top: 40%;
    }
  }

</style>
